"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useReactiveBaseProps = void 0;
const react_1 = __importDefault(require("react"));
const hooks_1 = require("../../hooks");
const package_json_1 = __importDefault(require("../../../package.json"));
const replaceDocCountWithParent = (response) => {
    Object.entries(response)
        .filter(([key]) => key !== "doc_count")
        .forEach(([key, value]) => {
        var _a;
        (_a = value.buckets) === null || _a === void 0 ? void 0 : _a.forEach((bucket) => {
            if (bucket.parent_docs) {
                bucket.doc_count = bucket.parent_docs.doc_count;
                delete bucket.parent_docs;
            }
        });
    });
    return response;
};
const useReactiveBaseProps = () => {
    const { options } = (0, hooks_1.useReactifySearchContext)();
    const reactiveBaseProps = react_1.default.useMemo(() => ({
        app: options.index,
        url: options.endpoint,
        credentials: options.credentials,
        theme: options.theme,
        transformResponse: (response) => __awaiter(void 0, void 0, void 0, function* () {
            var _a, _b, _c, _d;
            // support filtering inside nested aggregations by moving the inner aggregation
            // up one level such that reactivesearch understands it
            //
            // see useReactiveFilterListProps > defaultQuery to see how a filter is being applied
            // to variant aggregations to ensure that only in stock sizes are displayed as filter
            // options, this involves a nested filter, which requires this fix
            //
            // https://github.com/appbaseio/reactivesearch/issues/1530
            if ((_b = (_a = response === null || response === void 0 ? void 0 : response.aggregations) === null || _a === void 0 ? void 0 : _a.reactivesearch_nested) === null || _b === void 0 ? void 0 : _b.reactify_nested_outer) {
                response.aggregations.reactivesearch_nested =
                    replaceDocCountWithParent((_d = (_c = response === null || response === void 0 ? void 0 : response.aggregations) === null || _c === void 0 ? void 0 : _c.reactivesearch_nested) === null || _d === void 0 ? void 0 : _d.reactify_nested_outer);
            }
            return response;
        }),
        headers: {
            "x-reactify-shop": options.shopifyPermanentDomain,
            "x-reactify-mode": options.mode,
            "x-reactify-client-id": options.clientId,
            "x-reactify-client-version": package_json_1.default.version,
            "x-reactify-ga": (0, hooks_1.getCookie)("_rs_ga"),
        },
    }), [options.index, options.endpoint, options.credentials, options.theme]);
    return reactiveBaseProps;
};
exports.useReactiveBaseProps = useReactiveBaseProps;
//# sourceMappingURL=useReactiveBaseProps.js.map